var disputeInfo = {
    additionalInfo: 'If you have any documents or comments that might help resolve your dispute, please <0>add them now.</0>',
    cancelThisDispute: 'CANCEL THIS DISPUTE',
    redispute: 'REDISPUTE THIS TRANSACTION',
    title: 'Dispute Summary',
    tooltipContent: "We're working to resolve your dispute—if you don't hear from us in the next 10 business days, please reach out via Online Chat.",
    uploadsOff: 'If you have any documents or comments that might help resolve your dispute, please use our <0>Online Chat</0> for guided instructions on how to share it with us.'
};
export default disputeInfo;
//# sourceMappingURL=disputeInfo.js.map